/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForAgencyGroupOutput
 */
export interface CriteriaForAgencyGroupOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForAgencyGroupOutput
     */
    agencyGroupEffective?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyGroupOutput
     */
    agencyGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyGroupOutput
     */
    agencyGroupName?: string | null;
}

export function CriteriaForAgencyGroupOutputFromJSON(json: any): CriteriaForAgencyGroupOutput {
    return CriteriaForAgencyGroupOutputFromJSONTyped(json, false);
}

export function CriteriaForAgencyGroupOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForAgencyGroupOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencyGroupEffective': !exists(json, 'agencyGroupEffective') ? undefined : json['agencyGroupEffective'],
        'agencyGroupId': !exists(json, 'agencyGroupId') ? undefined : json['agencyGroupId'],
        'agencyGroupName': !exists(json, 'agencyGroupName') ? undefined : json['agencyGroupName'],
    };
}

export function CriteriaForAgencyGroupOutputToJSON(value?: CriteriaForAgencyGroupOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencyGroupEffective': value.agencyGroupEffective,
        'agencyGroupId': value.agencyGroupId,
        'agencyGroupName': value.agencyGroupName,
    };
}


